import React, { Component } from 'react'
import "antd/dist/antd.css";
import { message,  Button, Input, Table, Modal, Pagination, Row, Col} from 'antd';
import * as Action from '../../actions/onlineNumberInfo'
import {Scrollbars} from "react-custom-scrollbars";
import { HEADER_HEIGHT } from "../../constants";
const { Search } = Input;

export default class OnlineNumberInfo extends Component {
    constructor(props) {
        super(props);
        this.state = {
            start: 1, //当前页
            size: 10, //每页条数
            listTotal: 0, //列表总数
            searchValue: null, //搜索文字
            dataList:[]
        };
    }
    componentDidMount() {
        this.pageChange();
        this.getOnlineNumbers();
    }
    // 在线人数信息列表
    pageChange() {
        let params = {
            currentPage: this.state.start,
            pageSize: this.state.size,
        }
        if (this.state.searchValue) {
            params.query = this.state.searchValue
        }
        Action.getOnlineNumberList(params, (data) => {
            let dataList = [];
            if (data) {
                dataList = data
            }
            this.setState({
                dataList
            })
        }, (msg)=>{
            message.error(msg);
        })
    }
    // 在线列表人数
    getOnlineNumbers() {
        let params = {
            currentPage: this.state.start,
            pageSize: this.state.size,
        }
        Action.getOnlineNumber(params, (data) => {
            let listTotal = 0;
            if (data) {
                listTotal = data;
            }
            this.setState({
                listTotal
            })
        })
    }
    columns = [
        {
            key:'1',
            title: '账号',
            dataIndex: 'loginAccount',
            ellipsis: true,
            render:(value, row, index)=>{
                return <div>{row.account}</div>
            }
        },
        {
            key:'2',
            title: '登录IP',
            dataIndex: 'loginIp',
            textWrap: 'word-break',
            width: "400px",
            ellipsis: true,
            render:(value, row)=>{
                return <div>{row.loginIp}</div>
            }
        },
        {
            key:'3',
            title: '登录时间',
            dataIndex: 'loginTime',
            width: "400px",
            render:(value, row, index)=>{
                return <div>{row.loginDate}</div>
            }
        }
    ];

    // 重置
  reset = () => {
    this.setState({
      start: 1,
      size: 10
    })
    this.state.searchValue = null
    this.pageChange()
  }
  //搜索
  onSearch(value) {
    this.state.searchValue = value;
    this.state.start = 1;
    this.state.size = 10;
    this.pageChange();
  }
    render() {
        const {dataList,listTotal} = this.state
        let height = window.innerHeight - HEADER_HEIGHT; //浏览器窗口的内部高度-顶部导航的高度(上部分70) 
        return (
            <div style={{margin:"20px"}}>
                <div
                    style={{
                        backgroundColor: "#fff",
                        width:"100%"
                    }}
                >
                    <div
                        style={{
                            width: "100%",
                            height: "42px",
                            lineHeight: "42px",
                            padding: "0 15px",
                            borderBottom: "1px solid #f6f6f6",
                            color: "#62467a",
                            borderRadius: "2px 2px 0 0",
                            fontSize: "16px",
                            fontWeight: "bold",
                        }}
                    >
                        在线人员信息
                    </div>
                    <div style={{ display: "flex",justifyContent:"space-between", alignItems: "center", padding: "15px 0px 15px 15px" }}>  
                        <div style={{ display: "flex", alignItems: "center" }}>
                            <div style={{ width: "250px" }}>
                                <Search
                                    placeholder="请输入账号"
                                    onSearch={(value) => this.onSearch(value)}
                                    value={this.state.searchValue}
                                    onChange={(e) => {
                                    this.setState({
                                        searchValue: e.target.value,
                                    });
                                    }}
                                    style={{ width: 250 }}
                                />
                            </div>                    
                            <div>
                                <span style={{ marginLeft: "15px", cursor: "pointer" }} onClick={this.reset}>
                                    重置
                                </span>
                            </div>
                        </div>
                        <div style={{marginRight:"15px"}}>
                            <span>目前在线人数:</span>
                            <span style={{marginLeft:"10px"}}>{listTotal}</span>
                        </div>
                    </div>
                    <div style={{padding:"0px 15px",height:height-170}}>
                        <Scrollbars ref={(Scrollbars) => (this.scrollRef = Scrollbars)}>
                            <Table columns={this.columns} dataSource={dataList} pagination={false}/>
                        </Scrollbars>                         
                    </div>
                </div>
                <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginTop: "10px",
          }}
        >
          <Pagination
            // hideOnSinglePage={true}
            showQuickJumper
            current={this.state.start}
            pageSize={this.state.size}
            total={this.state.listTotal}
            showTotal={(total) => `共 ${total} 条`}
            showSizeChanger
            onChange={(page, pageSize) => this.onChange(page, pageSize)} //页码改变时回调
            onShowSizeChange={(page, pageSize) => {
              this.onChange(page, pageSize); //每页条数改变回调
            }}
          />
        </div>
            </div>
        )
    }

    // 页面改变时回调
    onChange(page, pageSize) {
        this.state.start = page;
        this.state.size = pageSize;
        // 每次改变页码时
        this.pageChange();
    }
}
